import React from 'react';
import { Link } from 'react-router-dom';

const Support = () => {
  return (
    <div className="page">
      <div className="page-header">
        <h1>📞 Support</h1>
        <p>
          Besoin d'aide pour intégrer l'API WhakUp ? Vous avez une question ou rencontrez un problème ?
          Nous sommes là pour vous aider.
        </p>
      </div>

      <div className="section">
        <h2>📧 Contactez le Support</h2>
        <p>
          Pour toute question technique ou demande d'assistance, contactez notre équipe support :
        </p>
        
        <div className="endpoint-card" style={{ background: '#f0f4ff', borderLeftColor: '#667eea' }}>
          <h3 style={{ marginTop: 0, color: '#667eea' }}>📬 Email Support</h3>
          <p style={{ fontSize: '1.1rem', marginBottom: '0.5rem' }}>
            <strong>support@whakup.com</strong>
          </p>
          <p style={{ color: '#666', margin: 0 }}>
            Réponse sous 24-48h en jours ouvrés
          </p>
        </div>
      </div>

      <div className="section">
        <h2>💬 Questions Fréquentes (FAQ)</h2>

        <div className="endpoint-card">
          <h3>Comment obtenir une API Key ?</h3>
          <p>
            Pour obtenir une API Key, contactez le support WhakUp ou utilisez votre tableau de bord administrateur.
            Une fois obtenue, vous pouvez l'utiliser pour vous authentifier via l'endpoint <code>/api/public/auth</code>.
          </p>
        </div>

        <div className="endpoint-card">
          <h3>Mon JWT a expiré, que faire ?</h3>
          <p>
            Les tokens JWT expirent après 24 heures. Réauthentifiez-vous simplement avec votre API Key
            en appelant à nouveau l'endpoint <code>/api/public/auth</code> pour obtenir un nouveau token.
          </p>
        </div>

          <div className="endpoint-card">
          <h3>Je reçois une erreur 429 (Rate Limit)</h3>
          <p>
            Vous avez dépassé la limite de requêtes autorisées. Consultez la page 
            <Link to="/rate-limiting" style={{ color: '#667eea', marginLeft: '0.5rem' }}>Rate Limiting</Link> pour
            comprendre les limites et implémenter une gestion appropriée. Attendez le temps indiqué
            dans le header <code>Retry-After</code> avant de refaire une requête.
          </p>
        </div>

        <div className="endpoint-card">
          <h3>Comment puis-je accéder à plusieurs workspaces ?</h3>
          <p>
            Une API Key est liée à un utilisateur, pas à un workspace spécifique. Après authentification,
            vous recevez la liste de tous vos workspaces. Utilisez l'endpoint <code>/api/public/workspaces</code>
            pour les récupérer, puis spécifiez le <code>X-Workspace-Id</code> dans vos requêtes.
          </p>
        </div>

        <div className="endpoint-card">
          <h3>Quand les autres fonctionnalités seront-elles disponibles ?</h3>
          <p>
            Les fonctionnalités comme la gestion des contacts, campagnes, et webhooks seront ajoutées
            progressivement à l'API publique. Restez informé en suivant nos mises à jour ou contactez le support
            pour connaître la roadmap.
          </p>
        </div>

        <div className="endpoint-card">
          <h3>Comment signaler un bug ou proposer une amélioration ?</h3>
          <p>
            Envoyez un email à <strong>support@whakup.com</strong> avec :
          </p>
          <ul>
            <li>Description détaillée du problème ou de la suggestion</li>
            <li>Exemples de requêtes/erreurs (sans données sensibles)</li>
            <li>Version de l'API utilisée</li>
            <li>Captures d'écran si applicable</li>
          </ul>
        </div>
      </div>

      <div className="section">
        <h2>📚 Ressources Utiles</h2>
        
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', gap: '1rem', marginTop: '1rem' }}>
          <div className="endpoint-card" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>🔐</div>
            <h3 style={{ marginTop: 0 }}>Authentification</h3>
            <p style={{ color: '#666', fontSize: '0.9rem' }}>
              Guide complet sur l'authentification avec API Key
            </p>
            <Link to="/authentication" style={{ color: '#667eea', textDecoration: 'none', fontWeight: 600 }}>
              En savoir plus →
            </Link>
          </div>

          <div className="endpoint-card" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>📡</div>
            <h3 style={{ marginTop: 0 }}>Endpoints</h3>
            <p style={{ color: '#666', fontSize: '0.9rem' }}>
              Documentation complète de tous les endpoints
            </p>
            <Link to="/endpoints" style={{ color: '#667eea', textDecoration: 'none', fontWeight: 600 }}>
              Voir les endpoints →
            </Link>
          </div>

          <div className="endpoint-card" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>💻</div>
            <h3 style={{ marginTop: 0 }}>Exemples</h3>
            <p style={{ color: '#666', fontSize: '0.9rem' }}>
              Exemples de code pour intégrer l'API
            </p>
            <Link to="/examples" style={{ color: '#667eea', textDecoration: 'none', fontWeight: 600 }}>
              Voir les exemples →
            </Link>
          </div>

          <div className="endpoint-card" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>⚡</div>
            <h3 style={{ marginTop: 0 }}>Rate Limiting</h3>
            <p style={{ color: '#666', fontSize: '0.9rem' }}>
              Comprendre et gérer les limites
            </p>
            <Link to="/rate-limiting" style={{ color: '#667eea', textDecoration: 'none', fontWeight: 600 }}>
              En savoir plus →
            </Link>
          </div>

          <div className="endpoint-card" style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2rem', marginBottom: '0.5rem' }}>❌</div>
            <h3 style={{ marginTop: 0 }}>Codes d'Erreur</h3>
            <p style={{ color: '#666', fontSize: '0.9rem' }}>
              Guide des erreurs et solutions
            </p>
            <Link to="/error-codes" style={{ color: '#667eea', textDecoration: 'none', fontWeight: 600 }}>
              Voir les erreurs →
            </Link>
          </div>
        </div>
      </div>

      <div className="section">
        <h2>🆘 Assistance Urgente</h2>
        <div className="alert alert-warning">
          <strong>⚠️ Problème critique ?</strong> Si vous rencontrez un problème bloquant affectant votre production,
          contactez immédiatement le support en indiquant "URGENT" dans l'objet de votre email pour une réponse prioritaire.
        </div>
      </div>

      <div className="section">
        <h2>🤝 Contribuer</h2>
        <p>
          Vous avez trouvé une erreur dans la documentation ? Vous souhaitez proposer une amélioration ?
          N'hésitez pas à nous contacter à <strong>support@whakup.com</strong> avec vos suggestions.
        </p>
      </div>
    </div>
  );
};

export default Support;
